import React from 'react';
import { useActiveAds } from './ActiveAdsContext';
import Ad from './Ad/Ad.js';
import { SaveAdProvider } from './Ad/SaveAd';
import { get } from '../fetcher';
import InfiniteScroll from 'react-infinite-scroll-component';

const apiUrl = (
  userId: string,
  page: number,
  baseUrl: string = ''
) => `${baseUrl}/trust-api/profile/searchApi/profile/SEARCH_ID_BAP_COMMON?client=profile&orgId=${userId}&page=${page}`;

const AktiveAnnonser: React.FunctionComponent = () => {
  const { metaData, docs, userId, setMetaData, apis } = useActiveAds();
  const [currentPage, setCurrentPage] = React.useState(metaData ? 2 : 1);

  const [activeAds, setActiveAds] = React.useState(docs);
  const getNewAds = async () => {
    if (metaData?.paging.last >= currentPage) {
      const data = await get(apiUrl(userId, currentPage, apis.baseUrl))
      if (data) {
        setActiveAds([...activeAds, ...data.docs]);
        setMetaData(data.metadata);
        setCurrentPage(currentPage + 1);
      }
    }
  }

  React.useEffect(() => {
    const getFirstPageIfNotSSRWorks = async () => {
      if (!metaData) {
        const data = await get(apiUrl(userId, currentPage, apis.baseUrl))
        if (data) {
          setActiveAds([...activeAds, ...data.docs]);
          setMetaData(data.metadata);
          setCurrentPage(currentPage + 1);
        }
      }
    }
    getFirstPageIfNotSSRWorks();
  }, []);

  return <div className='mb-32'>
    <h2 className="mb-16 h3">Aktive annonser på Torget</h2>
    <SaveAdProvider>
      <InfiniteScroll
        dataLength={activeAds?.length || 0} //This is important field to render the next data
        next={getNewAds}
        style={{ overflow: 'visible' }}
        hasMore={currentPage <= metaData?.paging.last}
        loader={<p className='mt-16'>Laster inn flere annonser...</p>}
        >
        <div className='sf-grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-16'>
          {activeAds?.map((ad, i) =>
            <Ad ad={ad} key={`ad-${i}`} onClick={() => {
                // can track this event if we want t
                }} />
          )}
        </div>
      </InfiniteScroll>
      {!activeAds?.length && <p>Ingen treff akkurat nå</p>}
    </SaveAdProvider>
  </div>
    ;
};

export default AktiveAnnonser;
